import gql from 'graphql-tag';

export default gql`
    query GetJobFiltersList {
        getJobFiltersList {
            customers {
                id
                name
            }
            districts {
                id
                name
            }
            regions {
                id
                name
            }
            statuses {
                id
                name
            }
        }
    }
`;
